<style lang="scss" scoped>
/* @import './send-resupply.modal';

    /deep/ .modal-body {
		border-radius: 5px;
		padding: 2rem;
		overflow: auto !important;
	} */
.modal-mask {
  position: fixed;
  z-index: 4;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.3s ease;
  font-size: 1rem;
}
.modal-content-container {
  background-color: #fff;
  min-width: 50vw;
  border-radius: 12px;
}
.new-request-modal__main-container {
  width: 80vw;
}
.manage-categories__header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  border-radius: 10px 10px 0px 0px;
  background-color: var(--primary-color);
}
.manage-categories__header-title {
  color: #ffffff;
  font-weight: 500;
  font-size: 1.2em;
}
.manage-categories__closebtn-icon {
  color: #ffffff;
  font-size: 1.8rem;
  cursor: pointer;
}
.new-page__actions-container {
  display: flex;
  align-items: flex-end;
  margin: 1.5em 1.2em;
  justify-content: space-between;
}
.new-page__search-input {
  width: 30vw;
  height: 3vw;
  border: 1px solid #c2c2c3;
  border-radius: 5px;
  padding-left: 0.5em;
  color: #898989;
}
.new-page__actions-title {
  font-size: 1rem;
  font-weight: 400;
  letter-spacing: 0.15px;
  color: #6e6e6e;
}
.new-page__right-actions {
  display: flex;
}
.edit-providers-btn {
  margin-right: 1em;
}
.page-filters__right-select-wrapper {
  display: flex;
  align-items: center;
}
.date-icon {
  background-color: var(--primary-color);
  color: #fff;
  cursor: pointer;
  padding: 8px 10px;
  border-radius: 0px 8px 8px 0px;
  position: relative;
  left: -6px;
}
.observation-input {
  width: 100%;
  height: 20vh;
  border: 1px solid #c2c2c3;
  border-radius: 5px;
  padding: 0 0 15vh 1vw;
  /* word-wrap: break-word; */
}
.overflow-container {
  overflow-x: auto;
  max-height: 40vh;
}
.modal-table-container {
  min-height: 40vh;
}
.new-page__table-container {
  margin: 1.2em;
}

.modal-table-header {
  display: flex;
  background: #fffefc;
  border: 0.5px solid #e5e5e5;
  padding: 1vh 0;
  font-weight: 400;
  font-size: 1rem;
  line-height: 17px;
  color: #605f5f;
  margin-bottom: 1vh;
}
.modal-table-colum {
  padding-left: 1vw;
}
.modal-table-row {
  display: flex;
  font-weight: 300;
  font-size: 0.8rem;
  color: #605f5f;
  margin-bottom: 2vh;
}
.checkbox-width {
  width: 8%;
}
.provider-width {
  width: 46%;
}
.seller-width {
  width: 46%;
}
.new-page__actions-title-wrapper {
  margin-bottom: 0.75vh;
}
.select-width {
  width: 17vw !important;
}
.datetime-width {
  width: 13vw !important;
  border-radius: 8px !important;
}
.group-width {
  width: 60%;
}

@media only screen and (max-width: 890px) {
  .mobile-container {
    flex-direction: column;
    align-items: center;
  }
  .select-width {
    width: 90vw !important;
  }
  .datetime-width {
    width: 85vw !important;
  }
  .obs-title-mobile {
    display: flex;
    justify-content: center;
  }
  .observation-input {
    width: 35vw;
    height: 8vh;
    padding: 0 0 5vh 1vw;
  }
  .new-page__actions-wrapper {
    margin: 0 auto;
  }
  .new-page__search-input {
    width: 50vw;
    height: 3vw;
  }
  .new-page__left-actions {
    margin: 0.5em 0em;
  }
  .modal-mask {
    font-size: 2vw;
  }
  .new-request-modal__main-container {
    width: 110vw;
  }
  .new-page__right-actions {
    gap: 2vw;
  }
}

@media only screen and (max-width: 680px) {
  .manage-categories__header-title {
    font-size: 20px;
  }
  .new-page__actions-title {
    font-size: 1rem;
  }
}

@media only screen and (max-width: 590px) {
}

@media only screen and (max-width: 400px) {
  .new-page__search-input {
    height: 8vw;
  }
}

@import "@/sass/commons/_variables";

/deep/ {
  .sub-title {
    padding: 0;
    text-transform: uppercase;
    color: $orange;
    font-weight: 600;
  }

  .multiselect__single {
    color: black !important;
  }

  .multiselect__option.multiselect__option--highlight {
    background-color: gray !important;
  }

  .modal-body {
    border-radius: 5px;
    padding: 2rem;
    overflow: auto !important;
  }
}
</style>
<template>
  <div class="modal-mask">
    <div class="modal-content-container">
      <div class="new-request-modal__main-container">
        <div class="manage-categories__header-container">
          <span class="manage-categories__header-title"> Enviar Cotação (V2) </span>
          <span
            @click="cancelDraftSend"
            class="material-icons manage-categories__closebtn-icon"
          >
            cancel
          </span>
        </div>
        <div class="new-page__actions-container">
          <div class="new-page__left-actions">
            <div class="new-page__actions-wrapper">
              <Button
                v-if="show_sellers"
                title="Voltar"
                :text="'Voltar'"
                :iconName="'arrow_back'"
                :action="
                  () => {
                    show_sellers = false;
                  }
                "
              />
            </div>
            <div class="new-page__actions-wrapper">
              <Button
                v-if="!show_sellers"
                title="Voltar"
                :text="'Voltar'"
                :iconName="'arrow_back'"
                :action="cancelDraftSend"
              />
            </div>
          </div>
          <div class="new-page__right-actions">
            <div class="new-page__actions-wrapper edit-providers-btn">
              <Button
                :disabled="!draftId || !ressuply.expiration_date || hasSelectedGroups"
                v-if="!show_sellers"
                title="Editar fornecedores"
                :text="'Editar Fornecedores'"
                :iconName="'people'"
                :action="loadDraftParticipants"
              />
            </div>
            <div class="new-page__actions-wrapper">
              <Button
                :disabled="!draftId || !ressuply.delivery_type || loading"
                title="Enviar"
                :text="'Enviar'"
                :iconName="'email'"
                :action="sendResuply"
              />
            </div>
          </div>
        </div>
        <template v-if="!show_sellers">
          <cc-loader-full v-if="loading" />
          <div>
            <div
              class="new-page__actions-container mobile-container"
              style="margin-bottom: 0"
            >
              <div class="new-page__actions-wrapper">
                <div class="new-page__actions-title-wrapper">
                  <span class="new-page__actions-title">Data Final</span>
                </div>
                <div class="page-filters__right-select-wrapper">
                  <datetime
                    :min-datetime="min_date"
                    ref="datepicker"
                    v-model="ressuply.expiration_date"
                    auto
                    :minute-step="10"
                    type="datetime"
                    class="form-control datetime-width"
                  ></datetime>
                  <span
                    @click="open_datepicker(0)"
                    class="material-icons-outlined date-icon"
                  >
                    today
                  </span>
                </div>
              </div>

              <StandardInput
                :placeholder="delivery_type_label"
                :action="(value) => (ressuply.delivery_type = value)"
                :list="deliveryTypes"
                class="select-width"
                :type="'disabled'"
                title="Tipo de Entrega"
              />

              <StandardInput
                :placeholder="
                  ressuply.payment_type
                    ? ressuply.payment_type.ttp_nome || ressuply.payment_type.text
                    : 'Selecione um pagamento'
                "
                :action="(value) => (ressuply.payment_type = value)"
                :list="payment_types"
                class="select-width"
                :type="'select'"
                title="Forma de Pagamento"
              />
              <StandardInput
                :placeholder="ressuply.payment_mandatory_type?.text || 'Selecione obrigatoriedade'"
                :action="(value) => (ressuply.payment_mandatory_type = value)"
                :list="paymentMandatoryTypes"
                class="select-width"
                :type="ressuply.payment_type ? 'select' : 'disabled'"
                title="Condição de Pgto."
              />
            </div>
            <div
              class="new-page__actions-container mobile-container"
              style="margin-top: 0"
            >
              <StandardInput
                :placeholder="'Selecione um grupo'"
                :action="handleGroupSelection"
                :list="groups"
                :type="'select'"
                class="group-width"
                title="Selecionar Grupos"
                :disabled="hasSelectedSellers"
              />
              <StandardInputAuto
                :action="(value) => (identifier = value)"
                :noIcon="true"
                placeholder="Insira um text"
                :type="'text'"
                :title="$store.state.identifierText"
              />
            </div>
            <div class="new-page__actions-container">
              <div class="new-page__actions-wrapper" style="width: 100%">
                <div class="new-page__actions-title-wrapper obs-title-mobile">
                  <span class="new-page__actions-title">Observação</span>
                </div>
                <input
                  class="observation-input"
                  type="text"
                  v-model="ressuply.observation"
                />
              </div>
            </div>
            <div class="new-page__actions-container">
              <cc-checkbox
                class="checkbox-title"
                @change="(evt) => (ressuply.is_public = evt.target.checked)"
                :checked="ressuply.is_public"
                :label="'Cotação Pública?'"
              />
            </div>
          </div>
        </template>
        <template v-if="show_sellers">
          <cc-loader-full v-show="loading" />
          <div class="new-page__actions-container">
            <div class="new-page__actions-wrapper">
              <div class="new-page__actions-title-wrapper">
                <span class="new-page__actions-title">Buscar</span>
              </div>
              <input
                class="new-page__search-input"
                @input="filter"
                :placeholder="'Digite o vendedor ou fornecedor'"
                type="text"
                v-model="filters.name"
              />
            </div>
          </div>
          <div class="new-page__table-container">
            <div class="overflow-container">
              <div class="modal-table-container">
                <div class="modal-table-header">
                  <div class="modal-table-colum checkbox-width">
                    <cc-checkbox
                      :checked="filters.check_all"
                      @change="(evt) => toggle_check(evt.target.checked)"
                    />
                  </div>
                  <div class="modal-table-colum provider-width">Fornecedor</div>
                  <div class="modal-table-colum seller-width">Vendedor</div>
                </div>
                <div
                  v-for="seller in sellers"
                  :key="seller.key"
                  v-show="seller.visible"
                >
                  <div class="modal-table-row">
                    <div class="modal-table-colum checkbox-width">
                      <cc-checkbox
                        :checked="seller.checked"
                        @change="(evt) => (seller.checked = evt.target.checked)"
                      />
                    </div>
                    <div class="modal-table-colum provider-width">
                      {{ seller.for_nome }}
                    </div>
                    <div class="modal-table-colum seller-width">
                      {{ seller.usu_nome }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import QuotationService from "@/services/QuotationService";
import { quotationDraftSendMixin } from "@/mixins/quotation-draft-send.mixin";
import ErrorHandlerService from "@/services/ErrorHandlerService";
import StorageService from "@/services/local-storage.service";
import SellerGroupService from "@/services/v2/seller-group.service";
import AuthService from "@/services/AuthService";
import { mapGetters } from "vuex";
import StandardInput from "@/components/ui/inputs/StandardInput.vue";
import StandardInputAuto from "@/components/ui/inputs/StandardInputAuto.vue";
import Button from "@/components/ui/buttons/Standard-Button.vue";

export default {
  mixins: [quotationDraftSendMixin],
  props: {
    quotations: Array,
    closeDialog: Function,
    sendParams: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  components: {
    Button,
    StandardInput,
    StandardInputAuto,
  },
  data() {
    return {
      service: new QuotationService(),
      storage_svc: new StorageService(),
      group_svc: new SellerGroupService(),
      auth_svc: new AuthService(),
      modal: {
        title: "enviar cotação",
        permitted: true,
        submit: this.sendResuply,
        submit_text: "Enviar",
        subtitle: "Envie sua cotação e receba as melhores ofertas no seu prazo",
        style: {
          width: "70%",
        },
      },
      deliveryTypes: [
        {
          value: { code: 1, text: "CIF" },
          text: "CIF",
        },
        {
          value: { code: 2, text: "CIF/FOB" },
          text: "CIF/FOB",
        },
      ],
      groups: [],
      payment_types: [],
      sellers: [],
      selectedSellers: [],
      identifier: "",
      filters: {
        name: "",
        check_all: true,
      },
      show_sellers: false,
      loading: false,
      ressuply: {
        is_public: false,
        expiration_date: this.sendParams.integrationData?.expiration_date || null,
        payment_type: this.sendParams.integrationData?.payment_condition
          ? { text: this.sendParams.integrationData.payment_condition }
          : null,
        observation: this.sendParams.integrationData?.observation || null,
        delivery_type: null,
        groups: null,
        payment_mandatory_type: null,
        payment_type: null,
      },
      paymentMandatoryTypes: [
        { text: "Obrigatória", value: true },
        { text: "Preferencial", value: false },
      ],
    };
  },
  methods: {
    toggle_check(val) {
      this.sellers.forEach((s) => (s.checked = val));
      this.filters.check_all = val;
      this.$forceUpdate();
      return val;
    },
    filter() {
      this.sellers.forEach((s) => (s.visible = false));
      let rx = new RegExp(this.filters.name, "gi");
      this.sellers
        .filter((s) => {
          if (!this.filter.name) return true;
          if (s.usu_nome && s.usu_nome.match(rx)) return true;
          if (s.for_nome && s.for_nome.match(rx)) return true;
        })
        .forEach((s) => (s.visible = true));
    },
    createDraft() {
      this.loading = true;
      this.draft_svc
        .create({ request_ids: this.quotations })
        .then((response) => {
          this.draftId = response.data.data.id;
        })
        .catch((error) => {
          this.notifyDraftError(error, "Não foi possível preparar o envio da cotação.");
          this.closeDialog();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleGroupSelection(value) {
      this.ressuply.groups = value;
      if (value) {
        this.sellers.forEach((s) => (s.checked = false));
      }
    },
    open_datepicker() {
      document.getElementsByClassName("vdatetime-input")[0].click();
    },
    close() {
      this.$emit("close");
    },
    load_payment_types() {
      this.service
        .list_payment_types()
        .then((response) => response.data)
        .then((data) => {
          this.payment_types = data.data.map((p) => {
            return { text: p.ttp_nome, value: p };
          });

          if (
            this.sendParams.isSingleQuotation &&
            this.sendParams.integrationData?.ttp_id
          ) {
            const paymentType = this.payment_types.find(
              (pt) => pt.value?.ttp_id === this.sendParams.integrationData?.ttp_id
            );
            if (paymentType) {
              this.ressuply.payment_type = paymentType.value;
            }
          }
        });
    },
    getStores() {
      this.service
        .getStoresClient()
        .then((response) => response.data)
        .then((data) => {
          this.stores = data.requisitantes.map((store) => {
            return {
              value: store.loj_id,
              name: store.loj_descricao,
            };
          });
          this.storeSelect = this.stores[0];
        })
        .catch((error) => {
          ErrorHandlerService.handle(error, this.$store);
        });
    },
    load_groups() {
      this.group_svc
        .all()
        .then((response) => response.data)
        .then((data) => {
          this.groups = [];
          data.forEach((element) => {
            this.groups.push({ text: element.nome, value: element });
          });
          this.groups.sort((a, b) => a.text.localeCompare(b.text));
        })
        .catch((error) => ErrorHandlerService.handle(error, this.$store));
    },
    sendResuply() {
      this.sendDraft(this.sendParams.manter_produto_zero ?? false);
    },
    load_tpc(tpc_id = StorageService.tpc()) {
      let resp = this.deliveryTypes.filter((d) => d.value.code == tpc_id);
      if (resp.length > 0) this.ressuply.delivery_type = resp[0].value;
    },
    load_settings() {
      let DEFAULT_PRIVATE_REQUESTS_SETTING = this.setting("DEFAULT_PRIVATE_REQUESTS");
      this.$set(
        this.ressuply,
        "is_public",
        DEFAULT_PRIVATE_REQUESTS_SETTING && DEFAULT_PRIVATE_REQUESTS_SETTING.value == "1"
      );
    },
    formatDate(date) {
      if (!date) return "";
      return moment(date).format("DD-MM-YYYY HH:mm");
    },
    verify_client_deployed() {
      this.auth_svc
        .get_user()
        .then((response) => response.data)
        .then(
          ({ usuario }) => {
            this.client = usuario.cliente;
            if (this.client.cli_implantado == 2) {
              this.load_settings();
            }

            // O cadastro do cliente e a fonte autoritativa do tipo de entrega e
            // vence o tpc_id do localStorage (que pode ser de outro usuario no
            // mesmo navegador): o campo e somente leitura, sem como corrigir.
            this.load_tpc(this.client.tpc_id);
          },
          (err) => {
            ErrorHandlerService.handle(err, this.$store, this.$store);
          }
        );
    },

    calculateDefaultExpiration() {
      if (this.sendParams.integrationData?.cot_dataExpiracao) {
        const apiDate = this.sendParams.integrationData.cot_dataExpiracao;
        if (apiDate.includes("T")) {
          return apiDate;
        } else {
          return moment(apiDate, "YYYY-MM-DD HH:mm:ss").toISOString();
        }
      }
      return moment().startOf("hour").add(3, "hours").toISOString();
    },
  },
  computed: {
    ...mapGetters({ setting: "user/setting" }),
    /**
     * O StandardInput com type 'disabled' renderiza somente a option do
     * placeholder: sem um texto ali o campo aparece em branco. Aceita o valor
     * em qualquer formato (objeto completo, so o codigo ou nulo).
     */
    delivery_type_label() {
      let delivery_type = this.ressuply.delivery_type

      if (!delivery_type) return '--'
      if (delivery_type.text) return delivery_type.text

      let code = delivery_type.code != null ? delivery_type.code : delivery_type
      let match = this.deliveryTypes.find((d) => d.value.code == code)

      return match ? match.text : '--'
    },

    min_date() {
      return moment().toISOString();
    },
    hasSelectedSellers() {
      return this.sellers.some((seller) => seller.checked);
    },
    hasSelectedGroups() {
      return !!this.ressuply.groups;
    },
  },
  mounted() {
    this.load_payment_types();
    this.getStores();
    this.load_tpc();
    this.load_groups();
    this.createDraft();
    this.verify_client_deployed();

    this.ressuply.expiration_date = this.calculateDefaultExpiration();
    if (this.sendParams.integrationData?.cot_observacao) {
      this.ressuply.observation = this.sendParams.integrationData.cot_observacao;
    }
  },
  watch: {
    payment_types: {
      handler(newPaymentTypes) {
        if (
          this.sendParams.isSingleQuotation &&
          newPaymentTypes.length > 0 &&
          this.sendParams.integrationData?.ttp_id
        ) {
          const paymentType = newPaymentTypes.find(
            (pt) => pt.value.ttp_id === this.sendParams.integrationData.ttp_id
          );

          if (paymentType && !this.ressuply.payment_type) {
            this.ressuply.payment_type = paymentType.value;
          }
        }
      },
      immediate: true,
    },
    sendParams: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (newVal.integrationData) {
          if (!newVal.isSingleQuotation) {
            this.ressuply.expiration_date = this.calculateDefaultExpiration();
            this.ressuply.payment_type = null;
            this.ressuply.observation = this.integrationData?.observation || null;
            return;
          }
          if (newVal.integrationData.cot_dataExpiracao) {
            const apiDate = newVal.integrationData.cot_dataExpiracao;
            let expirationDate;
            if (apiDate.includes("T")) {
              expirationDate = apiDate;
            } else {
              expirationDate = moment(apiDate, "YYYY-MM-DD HH:mm:ss").toISOString();
            }
            this.ressuply.expiration_date = expirationDate;
          } else {
            this.ressuply.expiration_date = this.calculateDefaultExpiration();
          }
          if (newVal.integrationData?.ttp_id && this.payment_types.length > 0) {
            const foundPaymentType = this.payment_types.find(
              (pt) => pt.value?.ttp_id === newVal.integrationData?.ttp_id
            );

            if (foundPaymentType) {
              this.ressuply.payment_type = foundPaymentType.value;
            }
          }
          this.ressuply.observation =
            newVal.integrationData.cot_observacao ||
            newVal.integrationData.observation ||
            null;
        }
      },
    },
    "ressuply.groups": {
      handler(newGroup) {
        if (newGroup) {
          this.sellers.forEach((s) => (s.checked = false));
        }
      },
    },
    selectedSellers: {
      handler(newSellers) {
        if (newSellers && newSellers.length > 0 && this.ressuply.groups) {
          this.ressuply.groups = null;
        }
      },
      deep: true,
    },
  },
};
</script>
